"use client";
// import "jsvectormap/dist/css/jsvectormap.css"
import "@/css/jsvectormap.scss";
import "flatpickr/dist/flatpickr.min.css";
import "nouislider/dist/nouislider.css";
import "dropzone/dist/dropzone.css";
import "@/css/satoshi.css";
import "@/css/simple-datatables.css";
import "@/css/style.css";
import React, { useEffect, useState } from "react";
import Loader from "@/components/Loader/CircleLoader";
import CookieBanner from "@/components/CookieBanner/CookieBanner";
import Script from "next/script";
import { Auth0Provider } from "@auth0/nextjs-auth0/client";
import { ProfileProvider } from "@/hooks/UserProfileContext";
import { ProjectsProvider } from "@/hooks/useProjectContext";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [loading, setLoading] = useState<boolean>(true);

  // Exclude non-production environments
  const isAnalyticsEnabled = process.env.NEXT_PUBLIC_ENV === "prod";
  const trackingId = process.env.NEXT_PUBLIC_GA_TRACKING_ID;

  // const pathname = usePathname();

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);

    if (isAnalyticsEnabled && trackingId) {
      window.dataLayer = window.dataLayer || [];

      // Define the gtag function
      window.gtag = (...args: any[]) => {
        window.dataLayer.push(args);
      };

      // Configure Google Analytics
      window.gtag("js", new Date());
      window.gtag("config", trackingId, {
        page_path: window.location.pathname,
      });
    }
  }, [isAnalyticsEnabled, trackingId]);

  return (
    <html lang="en">
      <head>
        <link rel="icon" href="/favicon.ico" sizes="any" />
        <link
          rel="preconnect"
          href="https://fonts.googleapis.com"
          crossOrigin="anonymous"
        />
        {isAnalyticsEnabled && trackingId && (
          <>
            <Script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${trackingId}`}
              strategy="afterInteractive"
            />
            <Script id="google-analytics" strategy="afterInteractive">
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${trackingId}', {
                  page_path: window.location.pathname,
                });
              `}
            </Script>
          </>
        )}
      </head>
      <CookieBanner />
      <body suppressHydrationWarning={true}>
        <Auth0Provider>
          <div className="dark:bg-boxdark-2 dark:text-bodydark">
            {loading ? <Loader /> : children}
          </div>
        </Auth0Provider>
      </body>
    </html>
  );
}
